import { render } from "./AdminConfigTab.vue?vue&type=template&id=5ff444fe"
import script from "./AdminConfigTab.vue?vue&type=script&lang=js"
export * from "./AdminConfigTab.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__